import { render, staticRenderFns } from "./AD.vue?vue&type=template&id=38dc37e5&scoped=true"
import script from "./AD.vue?vue&type=script&lang=js"
export * from "./AD.vue?vue&type=script&lang=js"
import style0 from "./AD.vue?vue&type=style&index=0&id=38dc37e5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38dc37e5",
  null
  
)

export default component.exports